import { render, staticRenderFns } from "./AvatarImageSelect.vue?vue&type=template&id=35c3a40f"
import script from "./AvatarImageSelect.vue?vue&type=script&lang=js"
export * from "./AvatarImageSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports